const replacements = {
    LLNL: 'Company 1',
    Leonardo: 'Company 2',
    BCAST: 'Company 3',
    'Astro Test Lab': 'Company 4',
    FAU: 'Company 5',
    QUT: 'Company 6',
    Element: 'Company 7',
    Constellium: 'Company 8',
    Arrival: 'Company 9',
    MPI: 'Company 10',
    MIT: 'Company 11',
    'Milwaukee Tool': 'Company 12',
    'University of Bolton': 'Company 13',
    'University of Pretoria': 'Company 14',
    'Boston Metal': 'Company 15',
    'Nanyang Technological University': 'Company 16',
    'Worcester Polytechnic Institute': 'Company 17',
    'Florida International University': 'Company 18',
    'University of British Columbia': 'Company 19',
    Plastometrex: 'Company 20',
    Morf3D: 'Company 21',
    '-': 'Company 22',
};

const replaceValues = (data, key) => {
    const dataValues = getKeysArray(data, key);
    const replacementsValues = Object.values(replacements);

    for (let i = 0; i < dataValues.length; i++) {
        if (replacementsValues.includes(dataValues[i])) {
            return data;
        }
    }

    return data.map((entry) => {
        const value = entry[key];
        const replacement = replacements.hasOwnProperty(value)
            ? replacements[value]
            : 'Company ';
        return { ...entry, [key]: replacement };
    });
};

const getKeysArray = (data, key) => {
    const values = Object.values(data);
    return values.map((value) => value[key]);
};

export default replaceValues;
